import React from "react"

const BlogCard = ({ blog, onReadMore, viewMode = 'grid' }) => {
  const isGraduation = blog.category === 'Graduation'
  return (
    <div className={`blog-card ${viewMode === 'list' ? 'list' : ''} ${isGraduation ? 'grad-ribbon-wrapper' : ''}`} tabIndex={0} aria-label={`Blog post: ${blog.title}`}>
      {isGraduation && <span className='grad-ribbon' aria-hidden='true'><i className='fa fa-graduation-cap'></i></span>}
      {/* Photo Count Badge */}
      {blog.additionalPhotos && blog.additionalPhotos.length > 0 && (
        <div className='photo-count-badge'>
          <i className='fa fa-camera'></i>
          {blog.additionalPhotos.length} Photos
        </div>
      )}
      
      <div className='blog-image-container'>
        <img src={blog.cover} alt={blog.title} className='blog-image' />
        <div className='blog-overlay'>
          <div className='blog-category'>{blog.category}</div>
        </div>
      </div>
      <div className='blog-content'>
        <div className='blog-meta'>
          <div className='meta-item'>
            <i className='fa fa-user'></i>
            <span>{blog.type}</span>
          </div>
          <div className='meta-item'>
            <i className='fa fa-calendar-alt'></i>
            <span>{blog.date}</span>
          </div>
          <div className='meta-item'>
            <i className='fa fa-clock'></i>
            <span>{blog.readTime}</span>
          </div>
        </div>
        <h2 className='blog-title'>{blog.title}</h2>
        <p className='blog-description'>{blog.desc}</p>
        <div className='blog-footer'>
          <div className='comments-info'>
            <i className='fa fa-comments'></i>
            <span>{blog.com}</span>
          </div>
          <button className='read-more-btn' onClick={() => onReadMore(blog)} aria-label={`Read more about ${blog.title}`}>
            Read More
            <i className='fa fa-arrow-right'></i>
          </button>
        </div>
      </div>
    </div>
  )
}

export default BlogCard
